const BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const token = () => localStorage.getItem('stok_token');

const headers = (json = true) => {
  const h = { Authorization: `Bearer ${token()}` };
  if (json) h['Content-Type'] = 'application/json';
  return h;
};

const handleRes = async (res) => {
  if (res.status === 401) {
    localStorage.removeItem('stok_token');
    localStorage.removeItem('stok_kullanici');
    window.dispatchEvent(new Event('stok_oturum_kapat'));
    throw new Error('Oturum süresi doldu');
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: 'Sunucu hatası' }));
    const e = new Error(err.detail || 'Hata');
    if (res.status === 409) e.isDuplicate = true;
    throw e;
  }
  if (res.status === 204) return null;
  return res.json();
};

export const api = {
  get:    (path)        => fetch(BASE + path, { headers: headers() }).then(handleRes),
  post:   (path, body)  => fetch(BASE + path, { method: 'POST',   headers: headers(), body: JSON.stringify(body) }).then(handleRes),
  put:    (path, body)  => fetch(BASE + path, { method: 'PUT',    headers: headers(), body: JSON.stringify(body) }).then(handleRes),
  del:    (path)        => fetch(BASE + path, { method: 'DELETE', headers: headers() }).then(handleRes),
  upload: (path, form)  => fetch(BASE + path, { method: 'POST',   headers: headers(false), body: form }).then(handleRes),
  excelUrl: (params = '') => `${BASE}/api/raporlar/excel${params}`,
  staticUrl: (yol)     => yol ? `${BASE}/${yol}` : null,
};

export const downloadExcel = async (params = '') => {
  const res = await fetch(BASE + '/api/raporlar/excel' + params, { headers: headers() });
  if (!res.ok) throw new Error('Excel oluşturulamadı');
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `stok-raporu-${new Date().toISOString().slice(0,10)}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
};
